const banners = [
	'images/home/banners/banner1.png',
	'images/home/banners/banner2.png',
	'images/home/banners/banner3.png',
];

export default banners;
